import React, { useEffect, useState } from "react";
import { apiClient } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Plus, Trash2, Shield } from "lucide-react";

const ROLE_STYLES = {
  admin: "text-destructive", manager: "text-primary", worker: "text-emerald-500",
};

export default function Team() {
  const [items, setItems] = useState([]);
  const [form, setForm] = useState({ email: "", name: "", role: "worker" });
  const load = () => apiClient().get("/team/members").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const add = async (e) => {
    e.preventDefault();
    try { await apiClient().post("/team/members", form); toast.success("Member added"); setForm({ email: "", name: "", role: "worker" }); load(); }
    catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };
  const del = async (id) => { await apiClient().delete(`/team/members/${id}`); load(); };

  return (
    <div className="space-y-6 fade-in-up" data-testid="team-page">
      <div>
        <h1 className="font-display text-5xl mt-1">Team</h1>
      </div>

      <form onSubmit={add} className="border border-border bg-card p-5 grid md:grid-cols-4 gap-3" data-testid="team-form">
        <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="team-name" aria-label="Name" className="border border-border bg-background px-3 py-2 text-sm" />
        <input required type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="team-email" aria-label="Email" className="border border-border bg-background px-3 py-2 text-sm" />
        <select value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="team-role" className="border border-border bg-background px-3 py-2 text-sm">
          <option value="admin">Admin</option>
          <option value="manager">Manager</option>
          <option value="worker">Worker</option>
        </select>
        <button data-testid="team-add-btn" className="btn-sharp inline-flex items-center justify-center gap-2 bg-primary text-primary-foreground px-4 py-2"><Plus className="h-4 w-4" /> Add</button>
      </form>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
        {items.length === 0 && <div className="text-sm text-muted-foreground col-span-full">No team members yet.</div>}
        {items.map((m) => (
          <div key={m.id} className="border border-border bg-card p-4" data-testid={`team-card-${m.id}`}>
            <div className="flex items-center justify-between">
              <div className="mono text-[10px] uppercase tracking-widest text-muted-foreground">
                <Shield className={`h-3 w-3 inline mr-1 ${ROLE_STYLES[m.role]}`} />{m.role}
              </div>
              <button onClick={() => del(m.id)} data-testid={`team-del-${m.id}`} className="text-muted-foreground hover:text-destructive"><Trash2 className="h-4 w-4" /></button>
            </div>
            <div className="font-heading text-lg mt-2">{m.name}</div>
            <div className="mono text-xs text-muted-foreground">{m.email}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
